<template>
  <section>
    <section class="pb-4" style="display: block;">
      <gift-list :query="query" @selected="onSelected" @updated="onRefresh" />
    </section>
    <section class="box" style="margin-top: 5px;">
      <gift-post-list ref="list" :gifts="selectedGifts" />
    </section>
  </section>
</template>

<script>
import GiftList from '@/components/gifts/GiftList'
import GiftPostList from '@/components/gifts/GiftPostList'

export default {
  name: 'Gifts',
  components: { GiftList, GiftPostList },

  data() {
    const { query } = this.$route

    return {
      query: query,
      selectedGifts: [],

      loadingGift: false
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  },
  methods: {
    onSelected(items) {
      this.selectedGifts = items
    },
    async onRefresh() {
      await this.$refs.list.refresh()
    }
  }
}
</script>
